import React from 'react';
import classNames from 'classnames';
const SelectValue = (props) => {
    const { items, prefix, disabled, type } = props;
    const clsPrefix = `${prefix}select`;
    const isInverse = type === 'inverse';
    return (React.createElement("div", { className: classNames({
            [`${clsPrefix}-value--inverse`]: isInverse,
            [`${clsPrefix}-value--disabled`]: disabled,
            [`${clsPrefix}-value--inverse-disabled`]: disabled && isInverse,
        }) }, items.join('，')));
};
export default SelectValue;
